(() => {
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));

  /* ---------- Header shadow once the page scrolls ---------- */
  const header = document.querySelector('[data-header]');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 10);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Slideshow ---------- */
  function initSlideshow(root) {
    if (root.dataset.vxReady) return;
    root.dataset.vxReady = '1';
    const track = root.querySelector('[data-vx-track]');
    const slides = $$('[data-vx-slide]', root);
    const dots = $$('[data-vx-dot]', root);
    if (!track || slides.length < 2) return;

    let index = 0;
    let timer = null;
    const speed = Number(root.dataset.speed) || 6000;
    const autoplay = root.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const go = (i) => {
      index = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[index].offsetLeft, behavior: 'smooth' });
    };
    const mark = () => {
      const i = Math.round(track.scrollLeft / track.clientWidth);
      if (i !== index) index = i;
      dots.forEach((d, n) => d.classList.toggle('is-active', n === index));
    };
    const stop = () => { clearInterval(timer); timer = null; };
    const start = () => {
      if (!autoplay) return;
      stop();
      timer = setInterval(() => { if (!document.hidden) go(index + 1); }, speed);
    };

    let raf;
    track.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(mark); }, { passive: true });
    root.querySelector('[data-vx-prev]')?.addEventListener('click', () => { go(index - 1); start(); });
    root.querySelector('[data-vx-next]')?.addEventListener('click', () => { go(index + 1); start(); });
    dots.forEach((d) => d.addEventListener('click', () => { go(Number(d.dataset.vxDot)); start(); }));
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('touchstart', stop, { passive: true });
    root.addEventListener('focusin', stop);
    start();
  }

  /* ---------- Videos: play / pause on click ---------- */
  document.addEventListener('click', (e) => {
    const box = e.target.closest('[data-vx-video]');
    if (!box) return;
    const video = box.querySelector('video');
    if (!video) return;
    if (e.target.closest('a')) return;
    if (video.paused) {
      $$('[data-vx-video] video').forEach((v) => {
        if (v !== video && !v.paused) { v.pause(); v.closest('[data-vx-video]').classList.remove('is-playing'); }
      });
      video.play();
      box.classList.add('is-playing');
    } else {
      video.pause();
      box.classList.remove('is-playing');
    }
  });

  /* ---------- Product page: installments, discount label ---------- */
  const money = (cents) => (window.Saint && window.Saint.formatMoney)
    ? window.Saint.formatMoney(cents)
    : (Number(cents) / 100).toFixed(2);

  function initPdpPrice(root) {
    $$('[data-product]', root).forEach((wrap) => {
      if (wrap.dataset.vxPdpReady) return;
      wrap.dataset.vxPdpReady = '1';

      const inst = wrap.querySelector('[data-vx-installments]');
      const badge = wrap.querySelector('[data-vx-discount]');
      if (!inst && !badge) return;

      wrap.addEventListener('saint:variant', (e) => {
        const variant = e.detail;
        if (!variant) return;
        if (inst) {
          const count = Number(inst.dataset.count) || 6;
          const discount = Number(inst.dataset.discount) || 0;
          const unitEl = inst.querySelector('[data-vx-installment-price]');
          const cashEl = inst.querySelector('[data-vx-cash-price]');
          if (unitEl) unitEl.textContent = money(Math.round(variant.price / count));
          if (cashEl) cashEl.textContent = money(Math.round(variant.price * (100 - discount) / 100));
        }
        if (badge) {
          const compare = variant.compare_at_price;
          const pct = compare && compare > variant.price
            ? Math.round(((compare - variant.price) * 100) / compare)
            : 0;
          badge.hidden = pct === 0;
          badge.textContent = `- ${pct}%`;
        }
      });
    });
  }

  /* ---------- Product page: scarcity bar ----------
     The number lives in the visitor's browser: it starts somewhere between the
     min and the max and goes down one unit every other visit, never below min. */
  function initStockBar(root) {
    $$('[data-vx-stock]', root).forEach((el) => {
      if (el.dataset.vxReady) return;
      el.dataset.vxReady = '1';

      const min = Number(el.dataset.min) || 3;
      const max = Math.max(min, Number(el.dataset.max) || 6);
      const scale = Number(el.dataset.scale) || 14;
      const key = `vxStock:${el.dataset.key || 'product'}`;

      let state = null;
      try { state = JSON.parse(localStorage.getItem(key) || 'null'); } catch (e) { state = null; }
      if (!state || typeof state.units !== 'number') {
        state = { units: Math.floor(Math.random() * (max - min + 1)) + min, views: 0 };
      } else {
        state.units = Math.min(max, Math.max(min, state.units));
        if (state.views >= 2 && state.units > min) { state.units -= 1; state.views = 0; }
        else { state.views = (state.views || 0) + 1; }
      }
      try { localStorage.setItem(key, JSON.stringify(state)); } catch (e) { /* private mode */ }

      const units = el.querySelector('[data-vx-stock-units]');
      if (units) units.textContent = (el.dataset.unitsText || '[n]').replace('[n]', state.units);

      const fill = el.querySelector('[data-vx-stock-fill]');
      if (fill) {
        const pct = Math.max(6, Math.min(100, (state.units / scale) * 100));
        requestAnimationFrame(() => { fill.style.width = `${pct}%`; });
      }
    });
  }

  /* ---------- Product page: shipping estimate by IP region ---------- */
  function initShippingBox(root) {
    $$('[data-vx-shipping]', root).forEach((box) => {
      if (box.dataset.vxReady) return;
      box.dataset.vxReady = '1';

      const title = box.querySelector('[data-vx-shipping-title]');
      const reveal = (region) => {
        if (title && region) title.textContent = (box.dataset.template || '[region]').replace('[region]', region);
        else if (title && box.dataset.fallback) title.textContent = box.dataset.fallback;
        box.hidden = false;
      };
      const regionOf = (data) => [data && data.city, data && (data.region_code || data.region)]
        .filter(Boolean).join(', ');

      const ask = (url) => fetch(url).then((r) => (r.ok ? r.json() : Promise.reject()));

      ask('https://ipapi.co/json/')
        .then((data) => {
          const region = regionOf(data);
          if (!region) return Promise.reject();
          reveal(region);
        })
        .catch(() => ask('https://ipwho.is/').then((data) => {
          if (data && data.success === false) return Promise.reject();
          const region = regionOf(data);
          if (!region) return Promise.reject();
          reveal(region);
        }))
        .catch(() => reveal(null));
    });
  }

  /* ---------- Overlays: image zoom and story player ---------- */
  const svgIcon = (path) => `<svg viewBox="0 0 24 24" class="icon" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><path d="${path}"/></svg>`;
  const ICON_CLOSE = svgIcon('M5 5l14 14M19 5L5 19');
  const ICON_PREV = svgIcon('M15 4l-8 8 8 8');
  const ICON_NEXT = svgIcon('M9 4l8 8-8 8');

  let overlayOpen = null;
  function lockScroll(on) { document.documentElement.style.overflow = on ? 'hidden' : ''; }

  let lightbox = null;
  let lbImages = [];
  let lbIndex = 0;
  function ensureLightbox() {
    if (lightbox) return lightbox;
    lightbox = document.createElement('div');
    lightbox.className = 'vx-lightbox';
    lightbox.setAttribute('role', 'dialog');
    lightbox.innerHTML = `
      <span class="vx-lightbox__count" data-lb-count></span>
      <button type="button" class="vx-lightbox__close" data-lb-close aria-label="Close">${ICON_CLOSE}</button>
      <button type="button" class="vx-lightbox__nav vx-lightbox__nav--prev" data-lb-prev aria-label="Previous">${ICON_PREV}</button>
      <div class="vx-lightbox__stage"><img class="vx-lightbox__img" data-lb-img alt=""></div>
      <button type="button" class="vx-lightbox__nav vx-lightbox__nav--next" data-lb-next aria-label="Next">${ICON_NEXT}</button>`;
    document.body.appendChild(lightbox);

    lightbox.addEventListener('click', (e) => {
      if (e.target.closest('[data-lb-close]') || e.target === lightbox || e.target.classList.contains('vx-lightbox__stage')) closeOverlays();
      else if (e.target.closest('[data-lb-prev]')) showLbImage(lbIndex - 1);
      else if (e.target.closest('[data-lb-next]')) showLbImage(lbIndex + 1);
    });
    return lightbox;
  }
  function showLbImage(i) {
    if (!lbImages.length) return;
    lbIndex = (i + lbImages.length) % lbImages.length;
    lightbox.querySelector('[data-lb-img]').src = lbImages[lbIndex];
    lightbox.querySelector('[data-lb-count]').textContent = `${lbIndex + 1} / ${lbImages.length}`;
    const single = lbImages.length < 2;
    lightbox.querySelector('[data-lb-prev]').hidden = single;
    lightbox.querySelector('[data-lb-next]').hidden = single;
    lightbox.querySelector('[data-lb-count]').hidden = single;
  }
  function openZoom(gallery) {
    const slides = $$('[data-main-slide] img', gallery);
    lbImages = slides.map((img) => img.currentSrc || img.src).filter(Boolean);
    if (!lbImages.length) return;
    const active = gallery.querySelector('[data-thumb].is-active');
    const start = active
      ? $$('[data-main-slide]', gallery).findIndex((s) => s.dataset.mainSlide === active.dataset.thumb)
      : 0;
    ensureLightbox().classList.add('is-open');
    overlayOpen = lightbox;
    lockScroll(true);
    showLbImage(start < 0 ? 0 : start);
  }

  let storyModal = null;
  function ensureStoryModal() {
    if (storyModal) return storyModal;
    storyModal = document.createElement('div');
    storyModal.className = 'vx-story-modal';
    storyModal.setAttribute('role', 'dialog');
    storyModal.innerHTML = `
      <button type="button" class="vx-story-modal__close" data-story-close aria-label="Close">${ICON_CLOSE}</button>
      <video class="vx-story-modal__video" data-story-video controls playsinline></video>`;
    document.body.appendChild(storyModal);
    storyModal.addEventListener('click', (e) => {
      if (e.target === storyModal || e.target.closest('[data-story-close]')) closeOverlays();
    });
    return storyModal;
  }
  function openStory(src) {
    const modal = ensureStoryModal();
    const video = modal.querySelector('[data-story-video]');
    video.src = src;
    video.volume = 0.6;
    video.muted = false;
    modal.classList.add('is-open');
    overlayOpen = modal;
    lockScroll(true);
    video.play().catch(() => { video.muted = true; video.play().catch(() => {}); });
  }

  function closeOverlays() {
    if (!overlayOpen) return;
    overlayOpen.classList.remove('is-open');
    const video = overlayOpen.querySelector('video');
    if (video) { video.pause(); video.removeAttribute('src'); video.load(); }
    overlayOpen = null;
    lockScroll(false);
  }

  document.addEventListener('click', (e) => {
    const zoom = e.target.closest('[data-vx-zoom]');
    if (zoom) {
      const gallery = zoom.closest('.product__gallery');
      if (gallery) { e.preventDefault(); openZoom(gallery); }
      return;
    }
    const story = e.target.closest('[data-vx-story]');
    if (story) { e.preventDefault(); openStory(story.dataset.vxStory); }
  });

  document.addEventListener('keydown', (e) => {
    if (!overlayOpen) return;
    if (e.key === 'Escape') closeOverlays();
    else if (overlayOpen === lightbox && e.key === 'ArrowLeft') showLbImage(lbIndex - 1);
    else if (overlayOpen === lightbox && e.key === 'ArrowRight') showLbImage(lbIndex + 1);
  });

  /* ---------- Social proof counter ---------- */
  function initCounter(root) {
    $$('[data-vx-counter]', root).forEach((el) => {
      if (el.dataset.vxReady) return;
      el.dataset.vxReady = '1';

      const target = el.querySelector('[data-vx-counter-value]');
      const start = Number(el.dataset.startValue) || 0;
      const daily = Number(el.dataset.daily) || 0;
      const from = new Date(el.dataset.startDate);
      if (!target || !start || isNaN(from.getTime())) return;

      const days = Math.max(0, Math.floor((Date.now() - from.getTime()) / 86400000));
      const value = start + days * daily;
      target.textContent = value.toLocaleString(document.documentElement.lang || 'fr-FR');
    });
  }

  function init(root = document) {
    $$('[data-vx-slideshow]', root).forEach(initSlideshow);
    initPdpPrice(root);
    initStockBar(root);
    initShippingBox(root);
    initCounter(root);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
